import React from 'react'
import { omit, keys, sortBy, values } from 'lodash'
import moment from 'moment'
import { Panel, Checkbox, Row, Col } from 'react-bootstrap'
import Markdown from '../../lib/MarkdownField'

import { datesRange, randstr } from '../../../lib/Tools.js'

import Button from '../../components/Button.jsx'

// #TODO dont have this hardcoded here! dupe info
const TFDATE = "YYYY/MM/DD"
const TFTIME = "YYYY/MM/DD HH:mm:ss"

type Props = {
  // from dad
  trip: Object,
  onChange: Object => void, // changes => void
  Activities: Object, 
  route: Object, 
}

const emptyNotification = {
  enabled: false, 
  name: "", 
  title: "", 
  date: "", 
  time: "", 
}

/**
 * 
 */

const AgendaNotification = ({ notif, i, onChange, trip }) => (
  <Row 
    style={{
      borderTopWidth: i > 0 ? 1 : 0, 
      borderTopColor: "#666", 
      borderTopStyle: "solid",
      color: notif.enabled ? "black" : "#999",
      paddingTop: i > 0 ? 12 : 0, 
    }}
  >
    <Col sm={1} md={1}>
      <Checkbox 
        checked={notif.enabled}
        onChange={evt => {
          if (notif.customNotification) {
            onChange({ 
              ...trip.appNotifications,
              custom: {
                ...trip.appNotifications.custom,
                [notif.key]: { ...notif, enabled: evt.target.checked }
              }
            })
          }
          else {
            onChange({ 
              ...trip.appNotifications,
              enabledItemKeys: {
                ...trip.appNotifications.enabledItemKeys,
                [notif.key]: { ...notif, enabled: evt.target.checked }
              }
            })
          }
        }}
      />
    </Col>
    <Col sm={6} md={6}>
      <div><strong>Nombre: </strong>{notif.name}</div>
      <div><strong>Título: </strong>{notif.title}</div>
      <div><strong>Hora: </strong>{notif.time}</div>
      {
        notif.customNotification && 
        <Button 
          bsSize="xsmall" 
          glyph="remove"
          onClick={() => {
            onChange({ 
              ...trip.appNotifications,
              custom: omit(trip.appNotifications.custom, notif.key)
            })
          }}
        >
          Eliminar
        </Button>
      }
    </Col>
    <Col sm={5} md={5}>
      <Markdown 
        value={notif.text} 
        onChange={text => {
          console.log(text)
          onChange({ 
            ...trip.appNotifications,
            enabledItemKeys: {
              ...trip.appNotifications.enabledItemKeys,
              [notif.key]: { ...notif, text }
            }
          })
        }}
      />
    </Col>
  </Row>
)

/**
 * 
 */

const askForNewNotification = (dateWithWeek) => {
  const date = dateWithWeek.split(" ")[0]
  console.log(`askForNewNotification ${date}`)
  
  const name = prompt("Nombre de la notificación (en español)")
  if (!name) return null
  const title = prompt("Título de la notificación (en chino)")
  if (!title) return null
  const text = prompt("Texto de la notificación (en chino)")
  if (!text) return null
  const time = prompt(`Hora (en ${date}, formato HH:MM)`)
  if (!time) return null

  const key = `${date} ${time} ${randstr()}`
  
  return { name, title, text, time, date, key, customNotification: true, enabled: true }
}

const timeWithWeekDay = yyyymmdd => moment(yyyymmdd, "YYYY/MM/DD").format("YYYY/MM/DD dddd")

/**
 * 
 */

const List = ({ trip, onChange, Activities, route }: Props) => {
  console.log(`notification list list for trip ${trip._id}`)

  /* prerequisits */

  if (!trip.startDate) { return "Falta la fecha de inicio del viaje" }

  /* get the data */
  
  const list = {}
  const { custom, enabledItemKeys } = trip.appNotifications

  datesRange(trip.startDate, route.agenda.filter(x => x.type == "day").length)
    .forEach(d => { list[d.format("YYYY/MM/DD")] = [] })

  route.agenda.reduce((mDay, item, index) => {
    if (item.type == "day" && index > 0) {
      return mDay.add(1, "days")
    }
    else if (item.type == "activity" && item.time) {
      const sDay = mDay.format(TFDATE)
      const a = Activities[item.id]

      if (!list[sDay]) list[sDay] = []

      list[sDay].push({ 
        ...emptyNotification, 
        key: item.key,
        name: a.name, 
        title: a.title, 
        date: sDay, 
        time: item.time, 
        ...enabledItemKeys[item.key], // enabled, text
      })
    }
    // #TODO also consider cities, there may be transport times

    return mDay
    
  }, moment(trip.startDate))

  values(custom).forEach(notif => {
    const sDay = moment(notif.date).format(TFDATE)

    if (!list[sDay]) list[sDay] = []

    list[sDay].push(notif)
  })

  
  /* paint it */

  const sortedDateStrings = keys(list).sort()

  return (
    <div>
      {
        sortedDateStrings.map(dateString => (
          <Panel key={dateString}>
            <Panel.Heading>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <span>{timeWithWeekDay(dateString)}</span>
                <Button 
                  onClick={() => {
                    const notif = askForNewNotification(dateString)
                    const an = trip.appNotifications
                    if (notif) {
                      onChange({ ...an, custom: { ...an.custom, [notif.key]: notif } })
                    }
                  }}
                  glyph="plus"
                >
                  Añadir
                </Button>
              </div>
            </Panel.Heading>
            <Panel.Body>
              {
                sortBy(list[dateString], "time").map((notif, i) => (
                  <AgendaNotification key={notif.key} {...{notif, i, trip, onChange}} />
                ))
              }
            </Panel.Body>
          </Panel>
        ))
      }
    </div>
  )
}

export default List

